import { LoginForm } from "./components";
import styles from "./LoginPage.module.css";
import logoImg from "../../shared/assets/image-22-1.png";

function LoginPage() {
  return (
    <div className={styles.loginContainer}>
      <img className={styles.loginLogo} src={logoImg} alt="ilosta-logo" />
      <h1 className={styles.loginTitle}>
        Sign in to your account
      </h1>
      <LoginForm />
      <div className={styles.loginContactContainer}>
        <p className={styles.loginContact}>Not a member? </p>
        <a
          className={styles.loginContactLink}
          href="https://ilosta.com/contact"
        >
          Contact us to get started
        </a>
      </div>
    </div>
  );
}

export default LoginPage;
